export const DoppeActionTypeCouponsListViewerLang = {
    defaultTexts: {
        title: 'Coupon Name',
        description: 'Describe the coupon you want to promote',
        buttonText: 'Continue',
        couponButtonText: 'Shop',
    },
}